export default __webpack_public_path__ + "static/media/ar.9ad69750.svg";